export let fuwuList = [
  {name:"招聘",value:'zhaopin',filterList:[0,1,2]},//招聘
  {name:"求职",value:'qiuzhi',filterList:[3,4,5,6,7]},//求职
  {name:"律师",value:'lvshi',filterList:[]},//律师
  {name:"教育",value:'jiaoyu',filterList:[8,9,6]},//教育
  {name:"培训",value:'peixun',filterList:[8,9]},//培训
  {name:"融资",value:'rongzi',filterList:[2,10]},//融资
  {name:"投资",value:'touzi',filterList:[2,11]},//投资
  {name:"招商",value:'zhaoshang',filterList:[2,10]},//招商
  {name:"加盟",value:'jiameng',filterList:[2,10]},//加盟
  {name:"租房",value:'zufang',filterList:[12,13]},//租房
  {name:"售房",value:'shoufang',filterList:[12,13]},//售房
  {name:"汽车",value:'qiche',filterList:[14]},//汽车
  {name:"交友",value:'jiaoyou',filterList:[4,6]},//交友
  {name:"电商",value:'gouwu',filterList:[]},//电商
  {name:"美食",value:'meishi',filterList:[15,16]},//美食
  {name:"旅游",value:'lvyou',filterList:[]},//旅游
  {name:"健康",value:'jiankang',filterList:[]},//健康
]